// extracted by mini-css-extract-plugin
module.exports = {"root":"az_dIb","positionFixed":"az_eIb","positionAbsolute":"az_fIb","positionSticky":"az_gIb","positionStatic":"az_hIb","positionRelative":"az_iIb"};